import Breadcrumbs, { BreadcrumbsProps } from "components/BreadCrumb";
import { ReactNode } from "react";
import * as S from "./styles";

interface PageProps {
  children: ReactNode;
  breadcrumbs?: BreadcrumbsProps;
}

export function Page({ children, breadcrumbs }: PageProps) {
  return (
    <S.Container>
      <S.Content>
        {breadcrumbs && (
          <Breadcrumbs
            paths={breadcrumbs.paths}
            currentPage={breadcrumbs.currentPage}
          />
        )}
        <S.ChildrenWrapper>{children}</S.ChildrenWrapper>
      </S.Content>
    </S.Container>
  );
}
